// extracted by mini-css-extract-plugin
export var actionButton = "_yg-2";
export var card = "_yg-0";
export var errorCard = "_yg-3";
export var row = "_yg-1";